import React from 'react';
import Icon from "./Icon";

class Download extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Icon, this.props, /*#__PURE__*/React.createElement("svg", {
      className: this.props.className,
      width: "16px",
      height: "16px",
      viewBox: "0 0 21 20"
    }, /*#__PURE__*/React.createElement("g", {
      id: "icons",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "translate(-344.000000, -234.000000)",
      id: "download",
      className: "icon__fill",
      fill: "#7E8DA2"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "translate(344.376880, 234.000000)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M14,6 L10,6 L10,0 L4,0 L4,6 L0,6 L7,13 L14,6 L14,6 Z M0,15 L0,17 L14,17 L14,15 L0,15 L0,15 Z",
      id: "Shape"
    }))))));
  }

}

export default Download;